<template>
  <div class="act_lottery_scratch">
    <div class="wrap" :style="wrap_style">
      <canvas ref="canvas" :width="canvas_width" :height="canvas_height" @touchstart.prevent="touchStart"
              @touchmove.prevent="touchMove"
              @touchend.prevent="touchEnd">
      </canvas>
    </div>
    <!--<div class="again">再来一次</div>-->
  </div>
</template>
<script>
  import Vue from 'vue'
  import click_handler from '../../../tools/mgtv/click'
  import to_casher from '../../../tools/mgtv/casher'
  import {openLink} from '../../../tools/mgtv/link'
  import download from '../../../tools/mgtv/downapp'
  import {getJSON} from '../../../api/myaxios'
  import process_award from './process_award'
  import {lock, unlock} from '../../../tools/lockScroll'
  import {click_event,error_event} from '../../../tools/mgtv/analysis'
  import {process_error_action} from '../../../tools/mgtv/error_action'


  const cover = 'http://demo.htmleaf.com/1506/201506071547/img/scratcher.jpg';
  export default {
    name: "ScratcherLottery",
    props: {
      info: {
        type: Object
      }
    },
    data(){
      return {
        touch_move_times: 0, //刮除的面积，这个简单的以touchmove触发的次数
        award_info: null //奖品
      }
    },
    computed: {
      g_html_font_size(){
        return window.g_html_font_size
      },
      canvas_width(){
        return 6 * this.g_html_font_size
      },
      canvas_height(){
        return 3 * this.g_html_font_size
      },
      wrap_style(){
        if (!this.award_info) {
          return {
//            background: `url(${cover}) no-repeat`,
//            backgroundSize: 'cover'
          }
        } else {
          const award_img = this.award_info.icon;
          return {
            background: `url(${award_img}) no-repeat`,
            backgroundSize: 'cover'
          }
        }
      }
    },
    mounted(){
      this.init();
    },
    methods: {
      init(){

        //初始化，绘制封面
        this.award_info = null;
        this.touch_move_times = 0;
        this.ctx = this.$refs.canvas.getContext('2d');
        const cover_image = new Image();
        cover_image.src = cover;
        cover_image.onload = () => {
          this.ctx.drawImage(cover_image, 0, 0, this.canvas_width, this.canvas_height);
        }
//
//        this.ctx.fillStyle = '#aaaaaa';
//        this.ctx.fillRect(0, 0, canvas.width, canvas.height);
//        this.ctx.restore();
      },
      windowToCanvas(e) {//全局坐标转换为canvas坐标
        let x = e.targetTouches[0].clientX,
          y = e.targetTouches[0].clientY,
          bbox = this.$refs.canvas.getBoundingClientRect();
        return {
          x: x - bbox.left,
          y: y - bbox.top
        }
      },
      drawEraser(loc) {//擦除区域
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.arc(loc.x, loc.y, 15, 0, Math.PI * 2, false);
        this.ctx.clip();
        this.ctx.clearRect(0, 0, this.canvas_width, this.canvas_height);
        this.ctx.restore();
      },
      eraserAll() {//擦除全部
        this.ctx.save();
        this.ctx.clearRect(0, 0, this.canvas_width, this.canvas_height);
        this.ctx.restore();
      },
      touchStart(e){
        lock();
        if (this.touch_move_times === 0) { //只有在第一次刮的时候才会发出抽奖请求
          if (window.$bus.lottery.remain_chance <= 0) { //检查抽奖次数，只有scratch_time=0时才检查
//            window.$toast('抽奖机会不足');
            this.lottery_from_remote();
            return;
          }
          if (this.lottery()) { //只有成功触发click_handler中的抽奖函数,才表示开始刮奖了　click_handler可能会由于一些原因阻止函数的触发
            this.touch_move_times++;
            this.drawEraser(this.windowToCanvas(e));
          }
        } else if (this.touch_move_times > 0) {　//已经开始刮奖了　就不会用检查了
          this.touch_move_times++;
          this.drawEraser(this.windowToCanvas(e));
        }
      },
      touchMove(e){
        console.log('touchmove')
        if (this.touch_move_times > 0) {
          this.touch_move_times++;
          this.drawEraser(this.windowToCanvas(e));
        }
      },
      touchEnd(e){
        unlock();
        if (this.touch_move_times > 0) {
          if (this.touch_move_times > 100 && this.award_info) {
            this.eraserAll();//清空封面，展示奖品
            setTimeout(() => {
              process_award(this.award_info);
              this.init();
            }, 1000);
          }
        }
      },
      lottery_from_remote(){
        getJSON("//vipact3.api.mgtv.com/api/v1/act/lot/lot", {
          act_name: window.rootdata.act_name,
          ticket: window.$bus.user.ticket
        }).then(res => {
          if (!res) {
            window.$toast('请求接口超时，请重试');
            setTimeout(()=>{
              click_event('抽奖超时')
            },0)
            return;
          }
          if (res && res.ret === 0) {
            this.award_info = res.data;
            Vue.set(window.$bus.lottery, 'remain_chance', res.data.remain_chance);
            //自动停止
            setTimeout(()=>{
              click_event('抽奖成功')
            },0)
          } else {
            process_error_action(res.data.action,res.msg);
//            window.$toast(res.msg || '抽奖失败,请重试')
            this.init();　//重新开始抽奖
            setTimeout(()=>{
              click_event('抽奖失败_' + res.msg)
            },0)
          }
        }).catch(e => {
          error_event(e,"lottery_from_remote");
          window.$toast('抽奖失败,请重试')
          this.init();//重新开始抽奖
          setTimeout(()=>{
            click_event('抽奖异常')
          },0)
        })
      },
      lottery(){
        return click_handler(this.info.name + '-开始刮奖', this.lottery_from_remote, {
          need_login: true,
          need_act: true,
          need_new_user:this.info.action_info.need_new_user,
          need_vip_level: this.info.action_info.need_vip_level,
        });
      }

    }
    ,
    created(){
    }

  }
</script>
<style lang="stylus">

  .act_lottery_scratch
    position: relative

  .wrap
    width 6rem
    height 3rem
    background #8c8c8c


</style>





// WEBPACK FOOTER //
// src/components/ConfigUI/Lottery/ScratcherLottery.vue